import iconTemplate from './IconTemplate.jsx';

export default iconTemplate(
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
        id="Meeting-Room--Streamline-Flex"
    >
        <desc>{'Meeting Room Streamline Icon: https://streamlinehq.com'}</desc>
        <g id="meeting-room">
            <path
                id="Vector 690"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5.12549 7.38865c1.28593 -0.35479 2.46309 -0.35479 3.74902 0"
                strokeWidth={1}
            />
            <path
                id="Vector 691"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7 7.11804 7 12.625"
                strokeWidth={1}
            />
            <path
                id="Vector 1307"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m4.54235 12.5899 -0.30009 -1.8243c-0.10755 -0.77845 -0.67403 -1.34984 -1.33826 -1.34984h-0.10113l-1.2293 0.00863c-0.625004 0 -1.016177 -0.52689 -1.064208 -1.0537 -0.06792 -0.74495 0.23914 -1.66789 0.745118 -2.84414"
                strokeWidth={1}
            />
            <path
                id="Vector 1309"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m9.45765 12.5899 0.30009 -1.8243c0.10755 -0.77845 0.67406 -1.34984 1.33826 -1.34984h0.1011l1.2293 0.00863c0.625 0 1.0162 -0.52689 1.0642 -1.0537 0.068 -0.74495 -0.2391 -1.66789 -0.7451 -2.84414"
                strokeWidth={1}
            />
            <path
                id="Vector"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.3735 4.275c0.92903 0 1.45162 -0.522 1.45162 -1.45 0 -0.928 -0.52259 -1.45 -1.45162 -1.45 -0.92904 0 -1.451625 0.522 -1.451625 1.45 0 0.928 0.522585 1.45 1.451625 1.45Z"
                strokeWidth={1}
            />
            <path
                id="Vector_2"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M11.6265 4.275c-0.929 0 -1.4516 -0.522 -1.4516 -1.45 0 -0.928 0.5226 -1.45 1.4516 -1.45s1.4516 0.522 1.4516 1.45c0 0.928 -0.5226 1.45 -1.4516 1.45Z"
                strokeWidth={1}
            />
        </g>
    </svg>,
);
